<template>
    <div :class="{ 'fixed-header': isFixed }" class="header">
        <div class="logo">
            <img src="../../assets/sxz.png" alt="Logo">
            <span class="site-name">山水行迹</span>
        </div>
        <div class="header-desktop-menu">
            <el-menu mode="horizontal" class="nav-menu" @select="handleSelect">
                <el-menu-item index="home">首页</el-menu-item>
                <el-menu-item index="about">关于</el-menu-item>
                <el-menu-item index="journal">旅行日志</el-menu-item>
            </el-menu>
        </div>
        <button
            type="button"
            class="mobile-menu-btn"
            aria-label="打开菜单"
            @click="drawerVisible = true"
        >
            <i class="el-icon-menu"></i>
        </button>
        <el-drawer
            title="导航"
            :visible.sync="drawerVisible"
            direction="rtl"
            size="72%"
            :append-to-body="true"
            class="mobile-nav-drawer"
        >
            <el-menu class="mobile-nav-menu" @select="onMobileSelect">
                <el-menu-item index="home">首页</el-menu-item>
                <el-menu-item index="about">关于</el-menu-item>
                <el-menu-item index="journal">旅行日志</el-menu-item>
            </el-menu>
        </el-drawer>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isFixed: false,
            siteName: '山水行迹',
            drawerVisible: false
        };
    },
    mounted() {
      this.scrollEl = document.getElementById("app");
      if (this.scrollEl) {
        this.scrollEl.addEventListener("scroll", this.handleScroll);
      }
    },
    beforeDestroy() {
      if (this.scrollEl) {
        this.scrollEl.removeEventListener("scroll", this.handleScroll);
      }
    },
    methods: {
        navigate(key) {
            switch (key) {
                case 'login':
                    document.title = `${this.siteName} - 登录`;
                    this.$router.push({ name: 'IcpLogin' });
                    break;
                case 'home':
                    document.title = `${this.siteName} - 首页`;
                    this.$router.push({ name: 'IcpHome' });
                    break;
                case 'about':
                    document.title = `${this.siteName} - 关于`;
                    this.$router.push({ name: 'IcpAbout' });
                    break;
                case 'journal':
                    document.title = `${this.siteName} - 旅行日志`;
                    this.$router.push({ name: 'IcpJournal' });
                    break;
            }
        },
        handleSelect(key) {
            this.navigate(key);
        },
        onMobileSelect(key) {
            this.drawerVisible = false;
            this.navigate(key);
        },
      handleScroll() {
        const top = this.scrollEl ? this.scrollEl.scrollTop : window.scrollY;
        this.isFixed = top > 0;
      }
    }
};
</script>

<style scoped>
.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 180px;
    transition: background-color 0.3s;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;
    background-color: transparent;
    box-sizing: border-box;
    min-height: 56px;
}

.fixed-header {
    backdrop-filter: blur(3px);
    background-color: rgba(255, 255, 255, 0.5);
}

.logo {
    display: flex;
    align-items: center;
    flex-shrink: 0;
}

.logo img {
    width: 35px;
    height: 35px;
    margin-right: 10px;
}

.site-name {
    font-size: 23px;
    font-weight: bolder;
    white-space: nowrap;
}

.nav-menu {
    background-color: transparent;
    border-bottom: none;
}

.el-menu-item {
    font-size: 18px;
    font-weight: bolder;
}

.mobile-menu-btn {
    display: none;
    border: none;
    background: transparent;
    font-size: 26px;
    color: #303133;
    cursor: pointer;
    padding: 8px;
    line-height: 1;
}

.mobile-nav-menu {
    border-right: none;
}

@media (max-width: 992px) {
    .header {
        padding: 0 24px;
    }
}

@media (max-width: 768px) {
    .header {
        padding: 0 16px;
    }

    .site-name {
        font-size: 18px;
    }

    .logo img {
        width: 28px;
        height: 28px;
        margin-right: 8px;
    }

    .mobile-menu-btn {
        display: block;
    }
}
</style>
